module.exports = __webpack_public_path__ + "img/5.52775bb6.png";